import { navigateTo } from "../operator/common/navigationService";
import { SERVER_URL } from "../ServerUrl";
import {
  AUTH_LOADED,
  AUTH_ERROR,
  USER_LOADED,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  ALL_CUSTOMER_ERROR,
  ALL_CUSTOMERS_LOADED,
  OPERATOR_LOGIN_SUCCESS,
  OPERATOR_LOGOUT,
  OPERATOR_LOGIN_FAIL,
  OPERATOR_SIGNUP_FAIL,
  OPERATOR_SIGNUP_SUCCESS,
  OPERATOR_UPDATE_SUCCESS
} from "./types";
// Common
import { Alert } from "../admin/common/Alert";
import Swal from "sweetalert2";
// Axios
import axios from "axios";
// Redux
import setAuthToken from "../admin/utils/setAuthToken";

// Load User
export const loadUser = () => async (dispatch) => {
  if (sessionStorage.token) {
    setAuthToken(localStorage.token);
  }
  try {
    const res = await axios.get(`${SERVER_URL}/auth`);
    dispatch({
      type: USER_LOADED,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: AUTH_ERROR,
    });
  }
};

// Login admin
export const adminLogin =
  ({ email, password, role, history }) =>
    async (dispatch) => {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const body = JSON.stringify({ email, password, role });

      try {
        const res = await axios.post(`${SERVER_URL}/admin/login`, body, config);

        dispatch({
          type: LOGIN_SUCCESS,
          payload: res.data,
        });

        // Alert("success", `Login Successful`);
        Swal.fire({
          icon: "success",
          title: "Login Successful",
          text: "Welcome back!",
          timer: 2000,
          showConfirmButton: false,
        });

        sessionStorage.setItem("token", res.data.authToken);
        setAuthToken(res.data.authToken);

        history.push("/admin/dashboard");
      } catch (err) {

        dispatch({
          type: LOGIN_FAIL,
        });
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err?.response?.data?.message,
        });
      }
    };

export const loadAllCustomers = () => async (dispatch) => {
  if (sessionStorage.token) {
    setAuthToken(sessionStorage.token);
  }

  try {
    const res = await axios.get(`${SERVER_URL}/admin/customer`);

    dispatch({
      type: ALL_CUSTOMERS_LOADED,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: ALL_CUSTOMER_ERROR,
    });

    Alert("error", "Customers are not loaded");
  }
};

export const operatorSignup = (signupObj, history) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify(signupObj);

  try {
    const res = await axios.post(
      `${SERVER_URL}/operator/createOperator`,
      body,
      config
    );

    dispatch({
      type: OPERATOR_SIGNUP_SUCCESS,
      payload: res.data,
    });

    Swal.fire({
      icon: "success",
      title: "Thank you for Signing Up!",
      text: "The admin will verify your sign-up request and activate your account.",
      confirmButtonText: "OK",
    }).then(() => {
      history.push("/operator/login");
    });
  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: err?.response?.data?.message,
    });
    dispatch({
      type: OPERATOR_SIGNUP_FAIL,
    });
  }
};

export const loginOperator =
  ({ loginObj, history }) =>
    async (dispatch) => {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const body = JSON.stringify(loginObj);

      try {
        const res = await axios.post(
          `${SERVER_URL}/operator/login`,
          body,
          config
        );

        if (res.data.success === false) {
          // if operator is not verified
          Swal.fire({
            icon: "error",
            title: "Error",
            text: res?.data?.message,
          });
        } else {
          dispatch({
            type: OPERATOR_LOGIN_SUCCESS,
            payload: res.data,
          });
          sessionStorage.setItem("token", res.data.authToken);
          sessionStorage.setItem("userID", JSON.stringify(res.data.operator));

          // Alert("success", `Login Operator Successful`);
          Swal.fire({
            icon: "success",
            title: "Login Successful",
            text: "Welcome back!",
            timer: 2000,
            showConfirmButton: false,
          });
          history.push("/operator/dashboard");
        }
      } catch (err) {
        dispatch({
          type: OPERATOR_LOGIN_FAIL,
        });
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err?.response?.data?.message,
        });
      }
    };


export const updateOperator = (res) => {

  return (dispatch) => {
    dispatch({
      type: OPERATOR_UPDATE_SUCCESS,
      payload: res,
    });
  };
};



export const logoutOperator = (history) => (dispatch) => {
  // Clear session storage
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("userID");

  // Dispatch logout
  dispatch({ type: OPERATOR_LOGOUT });
  if (history) {
    history.push("/operator/login");
  }
};